export const BUTTON_SIZES = {
    sm: 'sm',
    md: 'md',
    lg: 'lg',
} as const

export const BUTTON_SIZES_ARRAY = Object.values(BUTTON_SIZES)
